import {
  Box,
  Button,
  Typography,
} from '@mui/material'
import { useSelector } from '@xstate/react'
import mixpanel from 'mixpanel-browser'
import { useContext, useEffect } from 'react'
import LmnBackButton from 'src/components/Dialogs/Lmn/common/LmnBackButton'
import { LmnContext } from 'src/components/Dialogs/Lmn/LmnDialog'
import styles from 'src/components/Lmn/Lmn.scss'
import { CDN_PATH } from 'src/constants/global'
import { getLmnMerchantName } from 'src/helpers/lmnHelpers'

const LmnCandidatePage = (): JSX.Element => {
  const { lmnContextService } = useContext(LmnContext)
  const { send } = lmnContextService
  const merchantName = useSelector(lmnContextService, getLmnMerchantName)

  useEffect(() => {
    mixpanel.track('view_lmn_overview')
  }, [])

  const handleNextStepClicked = (): void => {
    send('NEXT_LMN_STEP')
    mixpanel.track('completed_lmn_overview')
  }
  return (
    <Box display="flex" flexDirection="column" gap="10px">
      <Box className={styles.lmnDialogItemHeader}>
        <img src={`${CDN_PATH}/images/sika-check.svg`} alt="Checkmark" height="40" />
        <Typography variant="h4Bold" color="primary.main" marginTop="10px">
          You may qualify for an LMN
        </Typography>
        <Typography variant="body3" color="gray1.main" textAlign="center">
          We&apos;ll need a little bit more information so our healthcare providers can evaluate
          you for your Letter of Medical Necessity (LMN).
        </Typography>
        <Typography variant="body3" color="gray1.main" textAlign="center">
          This process will take on average
          {' '}
          <b>3 minutes</b>
          {' '}
          and is a
          {' '}
          <b>free consultation</b>
          .
        </Typography>
      </Box>
      <Box className={styles.lmnDialogContainer}>
        <Box className={styles.lmnDialogItemRow}>
          <Box className={styles.lmnDialogItemIconContainer}>
            <img
              className={styles.lmnDialogItemIcon}
              src={`${CDN_PATH}/images/asset-lmn-complete-forms.svg`}
              alt="Id icon"
            />
          </Box>
          <Box>
            <Typography variant="body3Bold" color="primary.main">
              1. Complete the intake form
            </Typography>
            <Typography variant="body3" color="gray1.main">
              Tell our healthcare providers about yourself and your current/past medical background.
            </Typography>
          </Box>
        </Box>
        <Box className={styles.lmnDialogItemRow}>
          <Box className={styles.lmnDialogItemIconContainer}>
            <img
              className={styles.lmnDialogItemIcon}
              src={`${CDN_PATH}/images/asset-lmn-id-verification.svg`}
              alt="Id icon"
            />
          </Box>
          <Box>
            <Typography variant="body3Bold" color="primary.main">
              2. Verify Your identity
            </Typography>
            <Typography variant="body3" color="gray1.main">
              Complete a phone verification and ID upload to verify Your identity.
            </Typography>
          </Box>
        </Box>
        <Box className={styles.lmnDialogItemRow}>
          <Box className={styles.lmnDialogItemIconContainer}>
            <img
              className={styles.lmnDialogItemIcon}
              src={`${CDN_PATH}/images/asset-lmn-healthcare-provider.svg`}
              alt="Id icon"
            />
          </Box>
          <Box>
            <Typography variant="body3Bold" color="primary.main">
              3. Chat with a healthcare provider
            </Typography>
            <Typography variant="body3" color="gray1.main">
              After submitting your forms, one of our healthcare providers will reach out
              over text to determine your LMN eligibility.
            </Typography>
          </Box>
        </Box>
        <Box className={styles.lmnDialogItemRow}>
          <Box className={styles.lmnDialogItemIconContainer}>
            <img
              className={styles.lmnDialogItemIcon}
              src={`${CDN_PATH}/images/asset-lmn-complete-purchase.svg`}
              alt="Id icon"
            />
          </Box>
          <Box>
            <Typography variant="body3Bold" color="primary.main">
              4. Complete your purchase, if approved
            </Typography>
            <Typography variant="body3" color="gray1.main">
              If approved for an LMN, come back to
              {' '}
              {merchantName}
              {' '}
              to complete your purchase.
              Check out with Sika to use your HSA/FSA.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Button
        className={styles.lmnButton}
        color="primary"
        fullWidth
        size="large"
        variant="contained"
        onClick={handleNextStepClicked}
      >
        <Typography variant="body2Bold">
          Continue
        </Typography>
      </Button>
      <LmnBackButton />
    </Box>
  )
}

export default LmnCandidatePage
